export default __webpack_public_path__ + "static/media/textile.ce0065ce.jpg";